module.exports = require('./src/index');



//////////////////
// WEBPACK FOOTER
// ./node_modules/martinez-polygon-clipping/index.js
// module id = 1072
// module chunks = 0